export default "__VITE_ASSET__BMF2u9z1__"